import React from 'react';
import { Navigate } from 'react-router-dom';
import { currentTenant, TenantFeatures } from './tenants';

interface FeatureRouteProps {
  feature: keyof TenantFeatures;
  /** Where a brand without the feature lands instead. */
  redirectTo?: string;
  children: React.ReactElement;
}

/** Renders the page only for a brand that has the feature, so a typed-in URL can't reach it either. */
const FeatureRoute: React.FC<FeatureRouteProps> = ({ feature, redirectTo = '/dashboard', children }) =>
  currentTenant.features[feature] ? children : <Navigate to={redirectTo} replace />;

export default FeatureRoute;
